//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { venues_list, timeSlot_list, playingField_list } from '@/apis/stadium'
export default {
    data() {
        return {
            config: {
                gymnasiums: [],
                motions: [],
                fieldCode: [],
            },
            form: {
                venueCode: '',
                fieldCode: '',
                sDate: '',
                eDate: '',
                date: '',
            },
            //table loading
            loading: false,
            //table data
            data: [],
            //table columns
            columns: [],
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    created() {
        this.columns.push({ title: '場次名稱', dataIndex: 'name', key: 'name', });
        this.columns.push({ title: '所屬場館', dataIndex: 'venueName', key: 'venueName', });
        this.columns.push({ title: '所屬場地', dataIndex: 'fieldName', key: 'fieldName', });
        this.columns.push({ title: '運動類型', dataIndex: 'sportTypeName', key: 'sportTypeName' });
        this.columns.push({ title: '場地狀態', dataIndex: 'status', key: 'status', width: 150, scopedSlots: { customRender: 'status' }, });
        this.columns.push({ title: '日期', dataIndex: 'time', key: 'time', width: 180, });
        this.columns.push({ title: '時段', dataIndex: 'timeSlot', key: 'timeSlot', width: 180, });
        this.columns.push({ title: '操作', key: 'operation', width: 330, scopedSlots: { customRender: 'action' }, });
    },
    mounted() {
        this.$nextTick(async () => {
            await this.onPageConfig();
            await this.onPageLoad();
        });
    },
    methods: {
        venueChange(venueCode) {
            let records = [];
            this.form.fieldCode = "";
            if (venueCode !== '') {
                playingField_list({ venueCode: venueCode, pageSize: 999, pageNumber: -1 }).then(res => {
                    if (res.code !== 0) {
                        return;
                    }
                    res.data.records.forEach(element => {
                        records.push({ id: element.fieldCode, name: element.fieldName });
                    });
                })
            }

            this.config.fieldCode = records;
        },
        async getSportType() {
            try {
                //加載運動類型
                const res = await playingField_list({ fieldName: '', venueCode: '', status: '', sportTypeCode: '', pageSize: 99, pageNumber: 1 }) || {};
                if (res.code == 0) {
                    this.config.motions = res.data.records;
                } else {
                    if (res.msg)
                        throw new Error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        async getVenues() {
            try {
                //加載所屬場館
                const res = await venues_list({ venueName: '', venueCode: '', venueState: '1', pageNumber: 1, pageSize: 999 }) || {};
                if (res.code == 0) {
                    this.config.gymnasiums = res.data.records;
                } else {
                    if (res.msg)
                        throw new Error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },

        async onPageConfig() {
            //await this.getSportType();
            await this.getVenues();
        },
        async onPageLoad(isPostBack) {
            if (this.loading) return;
            if (!isPostBack) {
                this.pagination.current = 1;
            }
            try {
                this.loading = true;
                if (this.form.date) {
                    this.form.sDate = this.form.date.format('YYYY-MM-DD');
                    this.form.eDate = this.form.date.format('YYYY-MM-DD');
                } else {
                    this.form.sDate = ''
                    this.form.eDate = ''
                }


                //this.$moment(this.form.date).format('YYYY-MM-DD');

                const res = await timeSlot_list({
                    ...this.form,
                    pageNumber: this.pagination.current,
                    pageSize: this.pagination.pageSize
                }) || {};
                if (res.code == 0) {
                    this.data = res.data.records.map(item => {
                        return {
                            ...item,
                            timeSlot: `${item.startTime}-${item.endTime}`,
                        }
                    });
                    this.pagination.total = res.data.total;
                } else {
                    if (res.msg)
                        throw new Error(res.msg);
                }

            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.loading = false;
            }
        },
        //獲取運動類型名稱
        getSportTypeName(code) {
            if (code && this.config.motions) {
                const data = this.config.motions.filter(item => item.typeCode == code);
                if (data && data.length > 0) {
                    return data[0].name
                }
            }
            return code;
        },

        //頁面事件
        handleTableChange(pagination, filters, sorter) {
            this.pagination.current = pagination.current;
            this.onPageLoad(true);
        },
        //搜尋表單提交
        handleSearchSubmit(e) {
            e.preventDefault();
            this.onPageLoad(true);
        },
        //狀態更新
        async handleOnEditState(item, status) {
            //edit state
            try {
                const res = await venues_changeState(item.id, status);
                if (res.code == 0) {
                    this.onPageLoad(true);
                } else {
                    this.$message.error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        //刪除行
        async handleOnDelete(item) {
            try {
                const res = await venues_del(item.id);
                if (res.code == 0) {
                    this.onPageLoad(true);
                } else {
                    this.$message.error(res.msg);
                }
            } catch (error) {
                console.log('delete error', error);
            }
        },
        handleToDetails(id) {
            this.$router.push(`/matches-timeslot/${id}`);
        },
        handleToForm(id) {
            if (id > 0) {
                this.$router.push(`/matches-timeslot/form/${id}`);
            } else {
                this.$router.push('/matches-timeslot/form');
            }

        }
    }
}
